<template>
  <!-- 骨架屏 -->
  <div v-if="pageLoading" style="padding-top: 80px">
    <van-skeleton title :row="5" />
    <van-skeleton title :row="5" style="margin-top: 30px" />
  </div>
  <div v-else class="new-customer-gift">
    <!-- 顶部标题区域 -->
    <!-- <div class="header">
      <img
        class="logo"
        :src="require('@/assets/imgs/xibNewCustomerGift/logo.png')"
      />
    </div> -->

    <!-- 领取按钮 -->
    <div class="claim-btn" :class="[claimBtnClass]" @click="handleClaim"></div>

    <!-- 权益列表 -->
    <div class="benefit-list">
      <div
        class="benefit-item"
        v-for="(benefit, index) in benefitList"
        :key="index"
      >
        <!-- bg3: 左边档位定位的背景图 -->
        <div
          :class="[
            'benefit-header',
            `benefit-header-${index === 0 ? '1' : '3'}`,
          ]"
        />

        <div class="benefit-content">
          <div class="benefit-left">
            <div class="benefit-options">
              <!-- bg4: 钱 -->
              <div class="benefit-option">
                <div class="benefit-name">微信立减金</div>
                <img
                  :src="require('@/assets/imgs/xibNewCustomerGift/wx.png')"
                  alt="微信立减金"
                />
                <div class="benefit-price">{{ benefit.wechatBenefits[0] }}</div>
              </div>
              <div class="benefit-option">
                <div class="benefit-name">微信立减金</div>
                <img
                  :src="require('@/assets/imgs/xibNewCustomerGift/wx.png')"
                  alt="微信立减金"
                />
                <div class="benefit-price">{{ benefit.wechatBenefits[1] }}</div>
              </div>
            </div>
            <div class="benefit-options-tip">( 随机领取 )</div>
          </div>
          <!-- 本来有积分奖品后续需求变更删除 -->
          <!-- <div class="benefit-divider">或</div> -->
          <div class="benefit-divider"></div>
          <div class="benefit-right">
            <div
              :class="[
                'benefit-header',
                `benefit-header-${index === 0 ? '2' : '4'}`,
              ]"
            />
            <div class="benefit-options">
              <!-- bg4: 积分 -->
              <div class="benefit-option">
                <div class="benefit-name">微信立减金</div>
                <img
                  :src="require('@/assets/imgs/xibNewCustomerGift/wx.png')"
                />
                <div class="benefit-price">{{ benefit.pointBenefits[0] }}</div>
              </div>
              <div class="benefit-option">
                <div class="benefit-name">微信立减金</div>
                <img
                  :src="require('@/assets/imgs/xibNewCustomerGift/wx.png')"
                />
                <div class="benefit-price">{{ benefit.pointBenefits[1] }}</div>
              </div>
            </div>
            <div class="benefit-options-tip">( 随机领取 )</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 活动规则，领取记录 -->
    <ul class="benefit-info">
      <li class="rule" @click="ruleVisible = true"></li>
      <li class="record" @click="recordVisible = true"></li>
    </ul>
    <ruleModal :visible="ruleVisible" @confirm="ruleVisible = false" />
    <rewordModal
      :userRightsLevel="userRightsLevel"
      :visible="rewordVisible"
      :userRightsToken="userRightsToken"
      @confirm="rewordVisible = false"
      @close="rewordVisible = false"
    />
    <recordModal :visible="recordVisible" @confirm="recordVisible = false" />
  </div>
</template>

<script>
import ruleModal from "./components/ruleModal.vue";
import rewordModal from "./components/rewordModal.vue";
import recordModal from "./components/recordModal.vue";
import { preloadAllImages } from "./components/preloadImages.js";
import {
  login,
  queryReceiveStatus,
  xibNewCustomerCheck,
} from "@/api/xibNewCustomerGift";
export default {
  name: "xibNewCustomerGift",
  components: { ruleModal, rewordModal, recordModal },
  data() {
    return {
      // 权益等级JSON数据
      benefitList: [
        {
          title: "第1档",
          wechatBenefits: ["58元", "88元"],
          pointBenefits: ["158元", "218元"],
        },
        {
          title: "第2档",
          wechatBenefits: ["318元", "388元"],
          pointBenefits: ["518元", "688元"],
        },
      ],
      pageLoading: true, // 页面加载状态
      // 弹框
      ruleVisible: false,
      recordVisible: false,
      rewordVisible: false,
      userRightsToken: undefined, // 校验领取token
      userRightsLevel: undefined, // 校验领取等级
      receiveStatus: undefined, // 领奖状态：1可领奖，2不可参与当月达标次月领奖，3不可参与已领取奖励
    };
  },
  computed: {
    claimBtnClass() {
      if (![1, 2, 3].includes(this.receiveStatus)) return "";
      return `claim-btn-${this.receiveStatus}`;
    },
  },
  async mounted() {
    await preloadAllImages();
    await this.queryReceiveStatus();
    this.pageLoading = false;
    // this.handleLogin()
  },
  methods: {
    async handleLogin() {
      try {
        // 已登录不用登录
        if (sessionStorage.getItem("xibNewCustomerGiftToken")) {
          return;
        }
        const { token } = this.$route.query;
        const { code, data } = await login({ token });
        if (code !== 0) return;
        sessionStorage.setItem("xibNewCustomerGiftToken", data.token);
      } catch (error) {
        console.log(error);
      }
    },
    async handleClaim() {
      if (this.receiveStatus !== 1) return;
      try {
        const { code, data } = await xibNewCustomerCheck({});
        if (code !== 0) return;
        this.userRightsToken = data.userRightsToken; // 校验领取token
        this.userRightsLevel = data.level; // 用户可领取等级
        this.rewordVisible = true;
      } catch (error) {
        console.log(error);
      }
    },
    async queryReceiveStatus() {
      try {
        const { code, data } = await queryReceiveStatus({});
        if (code !== 0) return;
        const status = Number(data?.status);
        this.receiveStatus = [1, 2, 3].includes(status) ? status : undefined;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.new-customer-gift {
  position: relative;
  min-height: 100vh;
  background: url("~@/assets/imgs/xibNewCustomerGift/bg.png") no-repeat top
      center,
    #af2823;
  background-size: 100% auto;
  .logo {
    width: 80px;
    height: auto;
    margin: 20px 0 0px 15px;
  }
  .claim-btn {
    width: 203px;
    height: 73px;
    color: #fff;
    background-size: 203px 73px;
    cursor: pointer;
    margin: auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 420px;
    z-index: 22;
    background-repeat: no-repeat;
  }
  .claim-btn-1 {
    background-image: url("~@/assets/imgs/xibNewCustomerGift/signUpBtnBg1.png");
  }
  .claim-btn-2 {
    background-image: url("~@/assets/imgs/xibNewCustomerGift/signUpBtnBg2.png");
  }
  .claim-btn-3 {
    background-image: url("~@/assets/imgs/xibNewCustomerGift/signUpBtnBg3.png");
  }
  .benefit-list {
    position: relative;
    z-index: 1;
    padding: 508px 5px 20px;
    .benefit-item {
      margin-bottom: 10px;
      // overflow: hidden;
      position: relative;
      height: 151px;
      background: url("~@/assets/imgs/xibNewCustomerGift/eqBg1.png") no-repeat;
      background-size: 100% 100%;
      // bg3: 左边档位定位的背景图
      .benefit-header {
        position: absolute;
        top: -10px;
        left: -5px;
        z-index: 2;
        width: 72px;
        height: 62px;
        &.benefit-header-1 {
          background: url("~@/assets/imgs/xibNewCustomerGift/eqHeader1.png");
          background-size: contain;
        }
        &.benefit-header-2 {
          background: url("~@/assets/imgs/xibNewCustomerGift/eqHeader2.png");
          background-size: contain;
        }
        &.benefit-header-3 {
          background: url("~@/assets/imgs/xibNewCustomerGift/eqHeader3.png");
          background-size: contain;
        }
        &.benefit-header-4 {
          background: url("~@/assets/imgs/xibNewCustomerGift/eqHeader4.png");
          background-size: contain;
        }
      }
      .benefit-content {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        // padding: 30px 18px 29px 15px;
        padding-left: 10px;
        height: 100%;
        box-sizing: border-box;
        .benefit-left,
        .benefit-right {
          width: 132px;
          position: relative;
          .benefit-header {
            position: absolute;
            top: -34px;
            left: -30px;
          }
          .benefit-options {
            position: relative;
            z-index: 2;
            display: flex;
            justify-content: space-around;
            // padding: 0 10px;
            .benefit-option {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              position: relative;
              z-index: 2;
              width: 69px;
              height: 92px;
              background: url("~@/assets/imgs/xibNewCustomerGift/eqBg2.png")
                no-repeat;
              background-size: 100% 100%;
              // bg4: 钱跟积分的背景图
              .benefit-bg4 {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url("~@/assets/imgs/xibNewCustomerGift/eqBg4.png")
                  no-repeat;
                background-size: 100% 100%;
                z-index: -1;
              }
              .benefit-name {
                font-size: 8px;
                color: #e5713e;
                font-weight: bold;
              }
              img {
                width: 41px;
                height: 35px;
                margin: 5px 0 0;
                z-index: 3;
                position: relative;
              }
              .benefit-price {
                text-align: center;
                font-size: 9px;
                font-weight: bold;
                color: #fce7c2;
                width: 35px;
                height: 13px;
                line-height: 15px;
                background: url("~@/assets/imgs/xibNewCustomerGift/eqBg4.png");
                background-size: 100% 100%;
              }
            }
          }
          .benefit-options-tip {
            font-size: 8px;
            color: #c76832;
            text-align: center;
            font-weight: bold;
          }
        }
        .benefit-divider {
          width: 17px;
          height: 17px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          // background-color: #b33e12;
          margin: 0 10px;
          z-index: 3;
          position: relative;
          border-radius: 50%;
          color: #fce7c2;
          font-size: 9px;
          // margin: 0 8px;
        }
      }
    }
  }
  .benefit-info {
    position: absolute;
    right: 0;
    top: 170px;
    z-index: 22;
    .rule {
      width: 65px;
      height: 65px;
      background: url("~@/assets/imgs/xibNewCustomerGift/ruleBg.png");
      background-size: 100% 100%;
    }
    .record {
      width: 65px;
      height: 65px;
      background: url("~@/assets/imgs/xibNewCustomerGift/recordBg.png");
      background-size: 100% 100%;
    }
  }
}
</style>
